import { render, staticRenderFns } from "./ClubCardGettingError.vue?vue&type=template&id=4c720bfc&"
import script from "./ClubCardGettingError.vue?vue&type=script&lang=js&"
export * from "./ClubCardGettingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c720bfc')) {
      api.createRecord('4c720bfc', component.options)
    } else {
      api.reload('4c720bfc', component.options)
    }
    module.hot.accept("./ClubCardGettingError.vue?vue&type=template&id=4c720bfc&", function () {
      api.rerender('4c720bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubCardGetting/components/common/ClubCardGettingError.vue"
export default component.exports